import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApprovatorUser, State } from '../../../clients/interface/data.interface';
import { BreakpointObserver, Breakpoints, LayoutModule } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-filter-table-simulations',
  templateUrl: './filter-table-simulations.component.html',
  styleUrls: ['./filter-table-simulations.component.scss']
})
export class FilterTableSimulationsComponent {
  public filterForm: FormGroup;
  public selectFiltersFinalidad: Array<any> = [];
  public selectFiltersEstadoDeal: Array<any> = [];
  public groupedStates: Record<string, { id: number; name: string }[]> = {};
  
  @Input() states: State[] = [];
  @Input() approvators: ApprovatorUser[];
  @Output() filterState = new EventEmitter<string>();
  @Output() filterSearch = new EventEmitter<string>();
  @Output() filterAprove = new EventEmitter<number>();

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  public allStatus: string[] = [];
  public defaultSelectedIds: Set<number> = new Set([-7, -8, -12]);
  public selectedIds: Set<number> = new Set([-7, -8, -12]);
  public selectedIdsString: string = ''; 
  private debounceTimeout: any = null;
  public isMobile$: Observable<boolean>;

  constructor(private fb: FormBuilder, private breakpointObserver: BreakpointObserver) {
    this.filterForm = this.fb.group({
      start: null,
      end: null,
      searchCode: '',
      estado: [[-7, -8, -12]],
      search: '',
      aprove: 0
    });
  }

  ngOnInit(): void { 
    this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => result.matches)
    );
    this.emitFilterState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['states'] && changes['states'].currentValue) {
      this.allStatus = this.states.map(state => state.name);
      this.groupedStates = this.groupStatesByCondition();
    }
    if (changes['approvators'] && changes['approvators'].currentValue) {
      this.allStatus = this.states.map(state => state.name);
      this.groupedStates = this.groupStatesByCondition();
    }
  }

  public onSearch(): void {
    const search = this.filterForm.get('search')?.value;
    this.filterSearch.emit(search);
  }

  public onSelectSelectionChange(event: any): void {
    debugger;
    this.selectedIds = event.value;
    this.emitFilterState();
  }

  public onChipSelectionChange(event: any): void {
    const chipId = event.source.value;
    const isSelected = event.source.selected;
  
    if (isSelected) {
      this.selectedIds.add(chipId);
    } else {
      this.selectedIds.delete(chipId);
    }
  
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  
    this.debounceTimeout = setTimeout(() => {
      this.emitFilterState();
    }, 200); 
  }

  public onAproveSelectionChange(event: any): void {
    const aproveId = event.value;
    this.filterForm.get('aprove')?.setValue(aproveId);
    //this.filterAprove.emit(aproveId);
  }

  private emitFilterState(): void {
    const updatedSelectedIdsString = Array.from(this.selectedIds).join(',');
  
    if (this.selectedIdsString !== updatedSelectedIdsString) {
      this.selectedIdsString = updatedSelectedIdsString;
      this.filterState.emit(this.selectedIdsString);
    }
  }

  private groupStatesByCondition(): { [key: string]: any[] } {
    return {
      'Grupo 1': this.states.filter(state => [-1, -11, -10].includes(state.id)),
      'Grupo 2': this.states.filter(state => [-12, -8, -4].includes(state.id)),
      'Grupo 3': this.states.filter(state => [-3, -7].includes(state.id)),
      'Grupo 4': this.states.filter(state => [-5, -9, -6].includes(state.id)),
    };
  }

  public sendFilterAprove() {
    const aprove = this.filterForm.get('aprove')?.value;
    this.filterAprove.emit(aprove);
  }

}